import { Controller, useFormContext } from 'react-hook-form';

import { WrappedInput } from '@quick/components/Forms';

import { useAppTranslation } from '@/app/i18n/client';

import { useFormDataContext } from './FormDataContext';
import type { IForm } from './types';

export function ServicesQuantity() {
  const { t } = useAppTranslation(['common', 'demand']);
  const { control } = useFormContext<IForm>();

  const { modality } = useFormDataContext();
  const showServicesQuantity = modality?.service_quantity;

  if (!showServicesQuantity) return null;
  return (
    <Controller
      control={control}
      rules={{
        required: t('msg.required_field'),
        shouldUnregister: true,
        min: {
          value: 1,
          message: t('common:msg.min_number', { min: 1 }),
        },
        max: {
          value: 100,
          message: t('common:msg.max_number', { max: 100 }),
        },
      }}
      name="worker_quantity"
      render={({ field }) => (
        <WrappedInput
          {...field}
          isOnModal
          type="number"
          id="servicesQuantity-input"
          label={t('demand:declaredValue.servicesQuantity')}
          value={field.value ?? ''}
          onChange={(e) => {
            let value = Number.parseInt(e.target.value);
            if (value < 1) value = 1;
            if (value > 100) value = 100;
            field.onChange(Number.isNaN(value) ? undefined : value);
          }}
        />
      )}
    />
  );
}
